export type AutocompletePrediction = google.maps.places.AutocompletePrediction

export type PlaceResult = google.maps.places.PlaceResult

type GetPlaceDetailsFn = (options: google.maps.places.PlaceDetailsRequest) => Promise<PlaceResult | null>
type GetPlacePredictionsFn = (options: google.maps.places.AutocompletionRequest) => Promise<AutocompletePrediction[]>

const createPlacesService = (
  element: HTMLDivElement
): { getPlaceDetails: GetPlaceDetailsFn; getPlacePredictions: GetPlacePredictionsFn } => {
  if (!window.google?.maps?.places?.AutocompleteService)
    throw new Error(
      '[createPlacesService] AutocompleteService is not available. Please make sure that you have added the google map script to the page and have included the places lib (`&libraries=places`)'
    )

  if (!window.google?.maps?.places?.PlacesService)
    throw new Error(
      '[createPlacesService] PlacesService is not available. Please make sure that you have added the google map script to the page and have included the places lib (`&libraries=places`)'
    )

  if (!element) throw new Error('[createPlacesService] `element` of type HTMLDivElement was not provided.')

  const autocompleteService = new window.google.maps.places.AutocompleteService()

  const placesService = new window.google.maps.places.PlacesService(element)

  const getPlaceDetails: GetPlaceDetailsFn = (options) => {
    return new Promise((resolve, reject) => {
      placesService.getDetails(options, (result, status) => {
        if (status === google.maps.places.PlacesServiceStatus.OK) {
          return resolve(result)
        } else {
          return reject(status)
        }
      })
    })
  }

  const getPlacePredictions: GetPlacePredictionsFn = (options) => {
    return new Promise((resolve, reject) => {
      autocompleteService.getPlacePredictions(options, (result, status) => {
        if (status === google.maps.places.PlacesServiceStatus.OK) {
          return resolve(result || [])
        } else {
          return reject(status)
        }
      })
    })
  }

  return { getPlaceDetails, getPlacePredictions }
}

export default createPlacesService
